import { render } from "./DAToolbar.vue?vue&type=template&id=51babbd7&scoped=true"
import script from "./DAToolbar.vue?vue&type=script&lang=js"
export * from "./DAToolbar.vue?vue&type=script&lang=js"

import "./DAToolbar.vue?vue&type=style&index=0&id=51babbd7&lang=scss&scoped=true"

import exportComponent from "../../../../../CASRA/saoil/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51babbd7"]])

export default __exports__